import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/categoria/importer/categoriaImporterActions';

export default importerReducers(actions);
